import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Same config as the mobile app — copy from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyBOAZN2KfiQ0nuTohCqBLsL06jLAvmU-zs",
  authDomain: "buenos-dias-app-5333b.firebaseapp.com",
  projectId: "buenos-dias-app-5333b",
  storageBucket: "buenos-dias-app-5333b.firebasestorage.app",
  messagingSenderId: "955375965512",
  appId: "1:955375965512:web:da28801c08c47485764f7d",
  measurementId: "G-WG3HZHX8Z9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
